module.exports = __webpack_public_path__ + "static/media/Hula Dancer.ee3814fd.jpg";